import { render, staticRenderFns } from "./AppMessage.vue?vue&type=template&id=50f35e87&scoped=true&"
import script from "./AppMessage.vue?vue&type=script&lang=js&"
export * from "./AppMessage.vue?vue&type=script&lang=js&"
import style0 from "./AppMessage.vue?vue&type=style&index=0&id=50f35e87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f35e87",
  null
  
)

export default component.exports